import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import ResourceAvatar from '../ResourceAvatar';
import { styled } from '@mui/material/styles';
import { getSmallPictureVariant } from '../../utils/avatarUtils';

const RootStack = styled(Stack, { name: 'FormPaperLogo' })(({ theme }) => ({}));

// Workspaces that use a custom color for the workspace name shown next to the logo.
const CUSTOM_NAME_COLOR_WORKSPACES = {
  'space#05bc68a4da9d': '#1f4b8c',
  'space#152199833682': '#1f4b8c',
  'space#56adfe79953b': '#1f4b8c',
};

const FormPaperLogo = ({ workspace, ...rest }) => {
  const nameColor = CUSTOM_NAME_COLOR_WORKSPACES[workspace.pk];

  return (
    <RootStack
      flexWrap="wrap"
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      {...rest}
    >
      <ResourceAvatar
        variant="rounded"
        name={workspace.name}
        picture={workspace.picture}
        size={56}
      />
      <Typography variant="h6" sx={{ textAlign: 'center', color: nameColor }}>
        {workspace.name}
      </Typography>
    </RootStack>
  );
};

FormPaperLogo.propTypes = {
  workspace: PropTypes.shape({
    name: PropTypes.string.isRequired,
    picture: PropTypes.string,
  }).isRequired,
};

FormPaperLogo.defaultProps = {};

export default FormPaperLogo;
